import { AttachmentGroup } from "@rms-types/modules/attachment-group/entities/attachment-group";
import { Attachment } from "@rms-types/modules/attachment/entities/attachment";

import { attachmentGroupEndpoint } from "@/constants";
import { getQueryKey, getSnackbarMessages } from "@/helpers";
import { QueryFnData, useGet, UseGetOptions } from "@/hooks";

export function useGetAttachmentsById(
  attachmentGroupId: AttachmentGroup["id"],
  options: UseGetOptions<QueryFnData> = {}
) {
  const endpoint = attachmentGroupEndpoint.getAttachments(attachmentGroupId);
  const { triggerFetchErrorMessage } = getSnackbarMessages("Attachments");
  const queryKey = getQueryKey({ endpoint });

  const {
    data: attachments = [],
    error: attachmentError,
    refetch: refetchAttachments,
    isLoading: isAttachmentsLoading,
    ...rest
  } = useGet<Attachment[]>({
    endpoint,
    options: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: !!attachmentGroupId,
      ...options,
      onError: (error) => {
        options.onError && options.onError(error);
        triggerFetchErrorMessage();
      },
    },
  });
  return {
    attachments,
    isAttachmentsLoading,
    attachmentError,
    attachmentEndpoint: endpoint,
    attachmentQueryKey: queryKey,
    refetchAttachments,
    ...rest,
  };
}
